export default {
  locale: 'en',
  language: 'English',
  menu: {
    i18n: 'Internationalization'
  },
  page: {
    login: {
      title: 'Login',
      remember: 'Remember me',
      forgot: 'Forgot your password?',
      submit: 'Login',
      other: 'Sign in with',
      signup: 'Sign up'
    },
    register: {
      title: 'Register',
      submit: 'Register',
      other: 'Already have an account?'
    },
    exception: {
      e403: 'Sorry, you don\'t have access to this page.',
      e404: 'Sorry, the page you visited does not exist.',
      e500: 'Sorry, the server is reporting an error.',
      btn: 'Back to home'
    },
    i18n: {
      content: 'Hello, nice to meet you!'
    }
  }
};